






































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

interface Holder {
    id?: number;
    name: string;
    type: string;
    needPayAmount: string;
    needPayDate: string;
    needPayWay: string[];
    paidAmount: string;
    paidDate: string;
    paidWay: string[];
    accountBookId: number;
    year: number | string;
}

@Component
export default class Gdcz extends Vue {
    @Prop({ default: new Date().getFullYear() - 1 })
    year!: number;

    holderList = [
        "境内中国公民",
        "香港居民",
        "澳门居民",
        "台湾居民",
        "外国公民",
        "有限公司",
        "股份有限公司",
        "有限合伙企业",
    ];
    methodList = ["货币", "实物", "知识产权", "债权", "土地使用权", "股权","劳务", "其他"];

    form: Holder = {
        name: "",
        type: this.holderList[0],
        needPayAmount: "",
        needPayDate: this.$utils.simpleDateFormat(new Date(), "d", true),
        needPayWay: [],
        paidAmount: "",
        paidDate: "",
        paidWay: [],
        accountBookId: this.$store.state.accountBook.id,
        year: this.year
    }

    dataList = <Holder[]>[];

    mounted() {
        this.fetchData();
        if(this.$store.state.accountBook.accountBookInfo.province ===  "湖南省") {
            this.methodList = ["货币", "实物", "知识产权", "债权","高新技术成果", "土地使用权", "股权","劳务", "其他"];
        }
    }

    resetForm() {
        this.form = {
            name: "",
            type: this.holderList[0],
            needPayAmount: "",
            needPayDate: this.$utils.simpleDateFormat(new Date(), "d", true),
            needPayWay: [],
            paidAmount: "",
            paidDate: this.$utils.simpleDateFormat(new Date(), "d", true),
            paidWay: [],
            accountBookId: this.$store.state.accountBook.id,
            year: this.year
        }
    }

    async fetchData() {
        const res = await Vue.axios.get(`gsnb/gdjczxx/get?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        res.data.data.forEach((v: Holder) => {
            if (v.paidWay) v.paidWay = v.paidWay.toString().split(",");
            if (v.needPayWay) v.needPayWay = v.needPayWay.toString().split(",");
        });
        this.dataList = res.data.data;
    }

    async saveData(isEdit = false, data?: Holder) {
        const orgData = isEdit && data ? data : this.form;
        let formCopy: any = {};
        const keys = Object.keys(orgData);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            // @ts-ignore
            const value = orgData[key];
            if (key === "needPayWay" || key === "paidWay") {
                if (key === "paidWay") {
                    if ((orgData.paidAmount !== "" && +orgData.paidAmount !== 0) && value.length === 0) return;
                    else formCopy[key] = value.toString();
                } else {
                    if (value.length === 0) return;
                    else formCopy[key] = value.toString();
                }
            } else {
                if ((key === "paidDate" || key === "paidAmount")) {
                    if (orgData.paidAmount !== "" && +orgData.paidAmount !== 0 && (value === "" || value == null)) return;
                    else formCopy[key] = value;
                } else {
                    if (value === null || value === "") return;
                    else formCopy[key] = value;
                }
            }
        }
        await Vue.axios.post("gsnb/gdjczxx/save ", formCopy);
        await this.fetchData();
        if (!isEdit) this.resetForm();
    }

    async deleteData(id: number) {
        try {
            const action = await this.$confirm("确定要删除这条记录吗?", "温馨提示");
            if (action === "confirm") {
                await Vue.axios.delete(`gsnb/gdjczxx/delete?id=${id}`);
                this.fetchData();
            }
        } catch (e) {

        }
    }
}
